import { el, setAttr } from 'redom';

import application from 'application';

const STARTUP_FONT_FAMILY_VARIABLE = 'var(--startup-font-family)';

function buildFontFamilyLabel(fontFamily) {

  if (!fontFamily) {
    return 'Font';
  }

  if (fontFamily === STARTUP_FONT_FAMILY_VARIABLE) {
    return application.getCurrentStartup().theme.fontFamily;
  }

  return fontFamily;

}

class FontFamilyButtonSection {

  constructor(configuration) {

    this.label = el('span.font-family-button-label');

    this.button = el('button.inline-toolbar-button.font-family-button', {
      onclick: configuration.onToggle
    }, [this.label]);

    this.el = el('.font-family-button-section', [
      el('x-tooltip', { text: 'Font family' }, [this.button])
    ]);

    this.update(configuration.fontFamily);

  }

  update(fontFamily) {

    this.label.textContent = buildFontFamilyLabel(fontFamily);

    setAttr(this.label, {
      style: {
        fontFamily
      }
    });

  }

}

export default FontFamilyButtonSection;
